// Package Imports
import React, { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

// Project Imports
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';
import PrivateRouteConst from 'core/common/privateRouteConstant';

// Lazy-loaded Component
const BulkUser = lazy(() => import('pages/vendor/VendorBulk/bulkVendor'));

const BulkVendorRoute = (
  <Route
    path={routeName.bulkVendor}
    element={
      // <PrivateRoute name={PrivateRouteConst.USER_BULK_UPLOAD}>
      <PrivateRoute name={PrivateRouteConst.Vendor_BULK_UPLOAD}>
        <Suspense fallback={<Loading />}>
          <BulkUser />
        </Suspense>
      </PrivateRoute>
    }
  />
);

export default BulkVendorRoute;
